import gql from "graphql-tag";

export const USER_NOTES_QUERY = gql`
  query userNotes($userId: ID) {
    userNotes(userId: $userId) {
      id
      importance
      title
      note
      createdAt
      reminderDate
      reminderType
      coach {
        firstName
        lastName
      }
      assessment {
        id
        requiredDate
        number
      }
    }
  }
`;

export const HUBSPOT_NOTES_QUERY = gql`
  query hubspotNotes($ticketId: ID, $userId: ID) {
    hubspotNotes(ticketId: $ticketId, userId: $userId) {
      createdAt
      source
      body
    }
  }
`;

export const USER_NOTE_UPSERT_QUERY = gql`
  mutation upsertUserNote($input: CoachNoteInput!) {
    upsertCoachNote(input: $input) {
      ok
      new
    }
  }
`;

export const USER_NOTE_DELETE_QUERY = gql`
  mutation deleteUserNote($id: ID!) {
    deleteCoachNote(id: $id) {
      deleted
    }
  }
`;

export const USER_NOTE_COMPLETE_REMINDER_MUTATION = gql`
  mutation completeUserNoteReminder($id: ID!, $completed: Boolean!) {
    completeCoachNote(id: $id, completed: $completed) {
      success
    }
  }
`;